import { render, staticRenderFns } from "./CommerceHeader.vue?vue&type=template&id=874d5ac8"
import script from "./CommerceHeader.vue?vue&type=script&lang=js"
export * from "./CommerceHeader.vue?vue&type=script&lang=js"
import style0 from "./CommerceHeader.vue?vue&type=style&index=0&id=874d5ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports